import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=d4ac4cd6&scoped=true"
import script from "./Link.vue?vue&type=script&lang=ts"
export * from "./Link.vue?vue&type=script&lang=ts"
import style0 from "./Link.vue?vue&type=style&index=0&id=d4ac4cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ac4cd6",
  null
  
)

export default component.exports